const properties = {
  shape: 'circularImage',
  userNodeSize: 100,
  policyNodeSize: 100,
  resourceNodeSize: 50,
  groupNodeSize: 100,
  roleNodeSize: 100
};
export default properties;